import React from "react";
import Select from "react-select";

const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: "32px",
    fontSize: "12px",
    boxShadow: "none",
    borderColor: "var(--head-input-border-color)",
  }),
  indicatorSeparator: (provided) => ({ ...provided, display: "none" }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "12px",
    backgroundColor: state.isSelected ? "#e5ecffb2" : null,
    "&:hover": { backgroundColor: "#0000002E" },
  }),
};

// rent_status / sd_status aren't backed by /filter-data — they're a fixed,
// known enum, so the options are hardcoded and sent straight through as-is.
const STATUS_OPTIONS = [
  { label: "Paid", value: "paid" },
  { label: "Due", value: "due" },
  { label: "Partial", value: "partial" },
];

const FilterField = ({ label, value, options, onChange }) => (
  <div className="flex flex-col gap-1 px-3 py-2" style={{ minWidth: "13rem" }}>
    <label className="font-[var(--popover-heading-font-weight)] text-[length:--popover-font-size] text-[var(--popover-heading-fg-color)]">
      {label}
    </label>
    <Select
      styles={customStyles}
      isClearable
      isSearchable
      value={value ? options.find((opt) => opt.value === value) || null : null}
      onChange={(selected) => onChange(selected?.value ?? "")}
      options={options}
      placeholder={`All ${label}`}
    />
  </div>
);

const CocoOverviewFilter = ({
  filterData,
  setFilterData,
  filterOptions = {},
  setCurrentPage = () => {},
}) => {
  const updateField = (key) => (value) => {
    setFilterData((prev) => ({ ...prev, [key]: value }));
    setCurrentPage(1);
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        minWidth: "16rem",
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0px 1px 3px 0px var(--popover-shadow-color)`,
      }}
      className="absolute border border-[var(--popover-border-color)] border-solid border-1 py-3 bg-[var(--popover-bg-color)] rounded z-10 flex flex-col"
    >
      <span className="text-[length:--popover-heading-font-size] font-[var(--popover-heading-font-weight)] text-[var(--popover-heading-fg-color)] whitespace-nowrap px-[8px] pb-[8px]">
        FILTER BY
      </span>
      <hr className="border border-EAECF0" />
      <FilterField
        label="Creator"
        value={filterData?.creator_id}
        options={filterOptions.creators || []}
        onChange={updateField("creator_id")}
      />
      <FilterField
        label="City"
        value={filterData?.city}
        options={filterOptions.cities || []}
        onChange={updateField("city")}
      />
      <FilterField
        label="State"
        value={filterData?.state}
        options={filterOptions.states || []}
        onChange={updateField("state")}
      />
      <FilterField
        label="Rent Status"
        value={filterData?.rent_status}
        options={STATUS_OPTIONS}
        onChange={updateField("rent_status")}
      />
      <FilterField
        label="SD Status"
        value={filterData?.sd_status}
        options={STATUS_OPTIONS}
        onChange={updateField("sd_status")}
      />
    </div>
  );
};

export default CocoOverviewFilter;
